import API from "@/api/lib/api";

export const getAllCourses = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/courses`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleCourse = async (id) => {
  try {
    const response = await API.get(`restaurant/courses/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createCourse = async (data) => {
  try {
    const response = await API.post(`restaurant/courses`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateCourse = async (id, data) => {
  try {
    const response = await API.put(`restaurant/courses/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteCourse = async (id) => {
  try {
    const response = await API.delete(`restaurant/courses/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
